import { useGetUserInfoQuery } from '@/entities/admin-app/user/api';
import { useCurrentUser } from './useCurrentUser';
import { useEffect } from 'react';
import i18n from '@/entities/i18next';

export const useInitLocale = () => {
  const { userId } = useCurrentUser();
  const { data } = useGetUserInfoQuery(userId as number, {
    skip: !userId
  });
  const localLanguage = localStorage.getItem('lng');

  // Sync local storage with server language (server first)
  useEffect(() => {
    if (data?.Culture && data.Culture !== localLanguage) {
      localStorage.setItem('lng', data.Culture);
      i18n.changeLanguage(data.Culture);
    }
  }, [data]);
};
